module.exports = __webpack_public_path__ + "static/media/noImageXLH.dbdf6d57.jpg";